/* 🤖 this file was generated by svg-to-ts */
export const matIconComment: {
  name: 'comment';
  data: string;
} = {
  name: 'comment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM20 4v13.17L18.83 16H4V4h16zM6 12h12v2H6zm0-3h12v2H6zm0-3h12v2H6z"/></svg>`
};
